export const EDIT_FIRST_NAME = 'EDIT_FIRST_NAME';
export const EDIT_LAST_NAME = 'EDIT_LAST_NAME';
export const EDIT_SURNAME = 'EDIT_SURNAME';
export const EDIT_EMAIL = 'EDIT_EMAIL';
export const EDIT_PHONE = 'EDIT_PHONE';
export const CLEAR_PROFILE_FORM = 'CLEAR_PROFILE_FORM';
export const SWITCH_PERM_NEWS = 'SWITCH_PERM_NEWS';
export const SWITCH_PERM_MEDIUM_STATUS = 'SWITCH_PERM_MEDIUM_STATUS';

export function setCurrUserInProfile(
  first_name_profile, last_name_profile, surname_profile,
  email_profile, phone_profile, perm_news_profile,
  perm_system_messages_profile
) {
  return function (dispatch) {
    dispatch({
      type: EDIT_FIRST_NAME,
      first_name_profile
    });
    dispatch({
      type: EDIT_LAST_NAME,
      last_name_profile
    });
    dispatch({
      type: EDIT_SURNAME,
      surname_profile
    });
    dispatch({
      type: EDIT_EMAIL,
      email_profile
    });
    dispatch({
      type: EDIT_PHONE,
      phone_profile
    });
    dispatch({
      type: SWITCH_PERM_NEWS,
      perm_news_profile
    });
    dispatch({
      type: SWITCH_PERM_MEDIUM_STATUS,
      perm_system_messages_profile
    });
  }
}
